import * as React from 'react';
import { Redirect, useParams } from 'react-router-dom';

import { Routes } from '@/utils/routes';
import { formatShortDate } from '@/utils/formatter';
import i18n from '@/utils/i18n';
import { OrderDetailPage } from './components/details/OrderDetailPage';
import { OrderDetailsForm } from './components/details/OrderDetailsForm';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export const OrderDetails: React.FC = () => {
  const { orderId } = useParams<{ orderId: string }>();

  useDocumentTitle(i18n.t('MerchantOrder:orderDetails'));

  return (
    <OrderDetailPage
      orderId={orderId}
      breadcrumbLabel={(order) => {
        return `${order.store_name ?? i18n.t('Order:breadcrumbOrder')} - ${formatShortDate(order.created_at)}`;
      }}
      backRoute={Routes.orders()}
      backLabel={i18n.t('Order:breadcrumbBackToOrders')}
    >
      {({ order, refetch }) =>
        // Event orders have their own detail page/form; this open-system route
        // is wired to OrderDetailsForm, so redirect them to the event route
        // rather than render the wrong design (e.g. when opened from a link).
        order.system === 'EVENT' && order.event_id ? (
          <Redirect to={Routes.eventOrderDetail(order.event_id, order.id)} />
        ) : (
          <OrderDetailsForm order={order} refetch={refetch} />
        )
      }
    </OrderDetailPage>
  );
};
